<template>
  <div class="mall-class-detail">
      <div class="main" @scroll="scrollEvent" ref="scrollArea">
        <div class="top">
          <div
            class="top-img"
            v-if="obj.coverMap && obj.coverMap.url"
            :style="`background-image: url('${obj.coverMap.url}');`"
          ></div>
          <div class="top-info">
            <div class="info-box">
              <div class="product-name van-multi-ellipsis--l2">{{ obj.commodityName }}</div>
            </div>
          </div>
          <div class="product-price-name" v-if="obj.curriculumName">
            <span v-if="obj.curriculumName"> {{ obj.curriculumName }}</span>
          </div>
          <div class="price-info">
            <div class="price" v-if="obj.commodityPriceItemDetailList && obj.commodityPriceItemDetailList.length">
              <span style="font-size: 14px">¥</span>
              <span>{{ obj.minPrice | formatNumber}}</span
              >&nbsp;
              <span class="price-unit">{{
                obj.commodityPriceItemDetailList.length === 1 ? obj.commodityPriceItemDetailList[0].priceNum + `${obj.commodityPriceItemDetailList[0].priceUnitName}` : '起'
              }}</span>
            </div>
            <div class="price" v-else><span>暂无价格</span></div>
            <div class="stock">剩余{{ obj.remainingInventory }}个名额</div>
          </div>
          <div class="jifen" v-if="obj.enableMemberPoint">可积分抵扣</div>
        </div>
        <div class="section" v-if="obj.teachers && obj.teachers.length>0">
          <div class="section-title">授课老师</div>
          <div class="section-detail">
            <div class="teacher-info">
              <template v-if="obj.teachers && obj.teachers.length>0">
                <div class="teacher-item" v-for="itea in getTeachers(obj.teachers)" :key="itea.teacherId">
                  <img :src="itea.teacherPhoto && itea.teacherPhoto.url" class="teacher-photo" />
                  <div>
                    <div class="teacher-name">{{ itea.teacherName }}</div>
                    <div class="teacher-role">{{ itea.teacherRule === 0 ? '上课老师': '助教'}}</div>
                  </div>
                </div>
              </template>
              <!-- <div class="teacher-item" v-if="obj.assistantName">
                <img :src="obj.assistantPhoto && obj.assistantPhoto.url" class="teacher-photo" />
                <div>
                  <div class="teacher-name">{{ obj.assistantName }}</div>
                  <div class="teacher-role">助教</div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-title">上课信息</div>
          <div class="section-detail">
            <div class="class-info">
              <span class="info-left">上课地点：</span>
              <span class="info-right"
                >{{ obj.campusName
                }}<span v-if="obj.classRoomName">&nbsp;·&nbsp;{{ obj.classRoomName }}</span></span
              >
            </div>
            <div class="class-info">
              <span class="info-left">开课日期：</span>
              <span class="info-right" v-if="obj.planOpenClassTime">{{
                obj.planOpenClassTime | formatDatetime('yyyy-MM-dd')
              }}</span>
              <span class="info-right" v-else>未设置</span>
            </div>
            <!-- <div class="class-info">
              <span class="info-left">上课老师：</span>
              <span class="info-right">{{ getTeachers(obj.teachers) && getTeachers(obj.teachers).length>0 ? 
                  getTeachers(obj.teachers).map(i=>i.teacherName).join('、') : '未设置' }}
              </span>
            </div> -->
            <div class="class-info">
              <span class="info-left">上课时段：</span>
              <span
                class="info-right"
                v-html="formateClassTime(obj.commodityClassDetailExtendList)"
              ></span>
            </div>
          </div>
        </div>
        <div
          class="section"
          v-if="isEmptyContent(obj)"
        >
          <div class="section-title">课程介绍</div>
          <div class="section-detail">
            <vx-mult-input-show :list="obj.detailContent.list"></vx-mult-input-show>
          </div>
        </div>
        <div class="section" v-else>
          暂无课程介绍
        </div>
      </div>
      <div class="scroll-menu" :style="'opacity:' + menuOpacity">
        <div
          class="menu-box"
          @click="toAppointPage(index)"
          v-for="(item, index) in pageList"
          :key="item"
        >
          <div :class="{ active: currentPage === item }" style="display: inline-block">
            <div class="menu-ico">
              <van-icon
                name="location-o"
                color="#FF7837"
                v-if="currentPage === item"
                size="16"
                style="vertical-align: text-top"
              />
            </div>
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// function precision(num) {
//   return parseFloat(Number(num).toPrecision(12));
// }

export default {
  name: 'mall-class-detail',
  props: {
    obj: {
      type: Object,
  		default: {},
    }
  },
  data() {
    return {
      shareId: this.$route.query.shareId,
      pageList: ['课程', '上课信息', '课程介绍'],
      currentPage: '课程',
      menuOpacity: 0,
    };
  },
  methods: {
    isEmptyContent(obj) {
      return obj.detailContent && obj.detailContent.list && obj.detailContent.list.some(item=>{
        return item.type !== 'text' || (item.type == 'text' && item.content.trim() !== '');
      });
    },
    formateClassTime(val) {
      const weekdayArr = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
      if (!val) {
        return '';
      }
      let strVal = val
        .map(item => {
          if (weekdayArr[item.weekday - 1] && item.startTime) {
            return weekdayArr[item.weekday - 1] + item.startTime + '-' + item.endTime;
          }
        })
        .join('</br>');
      return strVal || '未设置';
    },
    getTeachers(teachers = [] ) {
      // 产品又要恢复助教显示，且后端让前端作排课(老师排前面)
      let arr = JSON.parse(JSON.stringify(teachers || []));
      return arr.sort((a,b)=> a.teacherRule - b.teacherRule);
    },
    scrollEvent(e) {
      const scrollTop = e.target.scrollTop;
      this.menuOpacity = scrollTop / 200;
      if (scrollTop < 450) {
        this.currentPage = '课程';
      } else if (scrollTop >= 680) {
        this.currentPage = '课程介绍';
      } else {
        this.currentPage = '上课信息';
      }
    },
    toAppointPage(index) {
      if (index === 0) {
        this.$refs.scrollArea.scrollTo(0, 0);
      } else if (index === 1) {
        this.$refs.scrollArea.scrollTo(0, 450);
      } else {
        this.$refs.scrollArea.scrollTo(0, 680);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mall-class-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .jifen {
    display: inline-block;
    margin: 0 calc(var(--gap) * 16);
    padding: 0 4px;
    border-radius: 2px;
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    background: rgba(255, 116, 55, 0.12);  
    color: #FF7437;
  }
  .main {
    flex: 1;
    overflow-y: auto;
    .top {
      background-color: var(--white);
      margin-bottom: calc(var(--gap) * 8);
      padding-bottom: calc(var(--gap) * 16);
      .top-img {
        width: 100%;
        height: 0;
        padding-top: 75%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
      }
      .top-info {
        margin: calc(var(--gap) * 16) 0 calc(var(--gap) * 6) calc(var(--gap) * 16);
        display: flex;
        justify-content: space-between;
        align-items: top;
        .info-box {
          flex: 1;
          .product-name {
            font-size: var(--fs-lg);
            font-weight: var(--bold);
          }
          .product-date {
            margin-top: calc(var(--gap) * 8);
            color: var(--g6);
            font-size: var(--fs-sm);
          }
        }
      }
      .price-info {
        padding: 0 calc(var(--gap) * 16);
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        .price {
          color: var(--c5);
          font-size: var(--fs-ex1);
          display: flex;
          align-items: baseline;
          .price-unit {
            font-size: var(--fs-xs);
            color: var(--g6);
          }
        }
        .stock {
          color: var(--g6);
          font-size: var(--fs-sm);
        }
      }
      .product-price-name {
        padding: 0 calc(var(--gap) * 47) calc(var(--gap) * 2)
          calc(var(--gap) * 16);
        color: var(--g6);
      }
    }
    .section {
      background-color: var(--white);
      margin-bottom: calc(var(--gap) * 8);
      padding: calc(var(--gap) * 16);
      .section-title {
        font-size: var(--fs-lg);
        font-weight: var(--bold);
      }
      .section-detail {
        margin: calc(var(--gap) * 16) 0 calc(var(--gap) * 8) 0;
        .teacher-info {
          display: flex;
          flex-wrap: wrap;
          .teacher-item {
            display: flex;
            align-items: center;
            margin: calc(var(--gap) * 4) calc(var(--gap) * 16) calc(var(--gap) * 4) 0;
            font-size: var(--fs-sm);
            .teacher-photo {
              width: calc(var(--w) * 32);
              height: calc(var(--w) * 32);
              border-radius: 50%;
              margin-right: 8px;
              background: var(--g4);
            }
            .teacher-name {
              color: var(--g7);
            }
            .teacher-role {
              color: var(--g6);
            }
            .item-right {
              margin-left: calc(var(--gap) * 8);
              color: var(--g6);
            }
          }
        }
        .class-info {
          display: flex;
          :not(:last-child) {
            margin-bottom: calc(var(--gap) * 16);
          }
          .info-left {
            color: var(--g6);
          }
          .info-right {
            flex: 1;
            color: var(--g6);
            line-height: calc(var(--w) * 22);
          }
        }
      }
    }
  }
  .scroll-menu {
    position: absolute;
    height: calc(var(--w) * 44);
    line-height: calc(var(--w) * 44);
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    background-color: var(--white);
    text-align: center;
    color: var(--g6);
    box-shadow: 0px -2px 12px 0px rgba(100, 101, 102, 0.12);
    .menu-box {
      flex: 1;
      .active {
        color: var(--c1);
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          height: calc(var(--w) * 3);
          background-color: var(--c1);
          left: 0;
          right: 0;
        }
      }
      .menu-ico {
        display: inline-block;
        width: calc(var(--w) * 16);
      }
    }
  }
}
</style>
